import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useUserContext } from "./UserContext";
import { getLoggedInUser, followUnfollowCoach } from "../api/index";
import { isUserProfileComplete } from "../../User/utils/profileCompletion";

const useOAuthHandler = () => {
  const { getUserFromToken } = useUserContext();
  const navigate = useNavigate();

  const handleSuccessfulLogin = async (token) => {
    try {
      const getUser = await getLoggedInUser({ token });
      console.log("OAuth successful login:", getUser);

      // Set user context FIRST before any navigation to prevent home page redirect
      await getUserFromToken(token);

      if (getUser.data.data.userType === "coach") {
        sessionStorage.removeItem("path");
        sessionStorage.removeItem("follow_id");

        if (getUser.data.data.profile_complete === "Yes") {
          navigate("/coach/profile");
        } else {
          navigate("/coach/onboarding-details");
        }
      } else if (getUser.data.data.userType === "user") {
        const rawPath = sessionStorage.getItem("path");
        const rawId = sessionStorage.getItem("follow_id");

        if (rawPath && rawId) {
          const path = JSON.parse(rawPath);
          const formdata = new FormData();
          formdata.append("coach_id", rawId);

          await followUnfollowCoach(formdata);
          navigate(`${path}`, { state: { reload: true } });

          sessionStorage.removeItem("path");
          sessionStorage.removeItem("follow_id");
        } else {
          // Check if user profile is complete for proper redirect
          const userData = getUser.data.data;
          if (isUserProfileComplete(userData)) {
            // Existing user with complete profile - redirect to browse coach
            navigate("/browse-coach/grid-view");
          } else {
            // New user with incomplete profile - redirect to edit profile
            navigate("/user/profile/edit-profile");
          }
        }
      } else {
        window.location.assign(window.location.href);
      }
    } catch (error) {
      console.error("Error in handleSuccessfulLogin:", error);
      toast.error("Failed to complete login process");
    }
  };

  useEffect(() => {
    // Check if we're returning from OAuth with response data
    const urlParams = new URLSearchParams(window.location.search);
    const response = urlParams.get("response");
    const error = urlParams.get("error");

    const handleOAuthResponse = async () => {
      console.log("OAuth response detected:", { response, error });

      if (response) {
        try {
          const payload = JSON.parse(decodeURIComponent(response));
          console.log("OAuth payload:", payload);

          if (payload.status && payload.token) {
            console.log("Storing token in localStorage:", payload.token);
            toast.success("Authentication successful!");
            localStorage.setItem("token", payload.token);

            // Call handleSuccessfulLogin to properly set up user session
            await handleSuccessfulLogin(payload.token);
          } else {
            console.error("OAuth payload missing status or token:", payload);
            toast.error(payload.message || "Authentication failed");
          }
        } catch (e) {
          console.error("Error parsing OAuth response:", e);
          toast.error("Invalid response from OAuth provider");
        }
      }

      if (error) {
        console.error("OAuth error:", error);
        toast.error(decodeURIComponent(error));
      }
    };

    // Only handle OAuth response if we have response or error parameters
    if (response || error) {
      handleOAuthResponse();
    }
  }, []); // Empty dependency array - only run once on mount

  return { handleSuccessfulLogin };
};

export default useOAuthHandler;
